(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beetles-monthly-challenge"] && !Shopify.designMode) return;
  try {
    
  function initializeMonthlyChallenge(section) {
    if (!section || section.dataset.faqInitialized) return;
    const firstQuestion = section.querySelector('.monthly-challenge__faq-item');
    if (firstQuestion) firstQuestion.open = window.matchMedia('(min-width: 750px)').matches;
    section.dataset.faqInitialized = 'true';
  }
  document.querySelectorAll('[data-monthly-challenge]').forEach(initializeMonthlyChallenge);
  document.addEventListener('shopify:section:load', function(event) {
    initializeMonthlyChallenge(event.target.querySelector('[data-monthly-challenge]'));
  });

  } catch(e) { console.error(e); }
})();
})();
